import React from 'react';
import { CircularProgress } from '@mui/material';

interface LoadingScreenProps {
  message?: string;
}

/**
 * Composant affichant un écran de chargement avec un indicateur circulaire
 * et un message optionnel.
 */
const LoadingScreen: React.FC<LoadingScreenProps> = ({ 
  message = 'Chargement en cours...' 
}) => {
  return (
    <div className="flex flex-col items-center justify-center min-h-[400px] p-8">
      <CircularProgress size={60} thickness={4} />
      <p className="mt-4 text-gray-600 text-center">{message}</p>
    </div>
  );
};

export default LoadingScreen;
